import { render, staticRenderFns } from "./IzdelajObrazec.vue?vue&type=template&id=f8395778&"
import script from "./IzdelajObrazec.vue?vue&type=script&lang=js&"
export * from "./IzdelajObrazec.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports